export default __webpack_public_path__ + "static/media/Example4.f0bf7991.jpeg";